module.exports = __webpack_public_path__ + "img/thumb-dean.f1c982e0.png";